export const ONE_HUNDRED_MB = 104_857_600;
